// extracted by mini-css-extract-plugin
module.exports = {"introductionContainer":"pages-fellows-fellows__introductionContainer--3ywdU"};